const { latitude, longitude } = JSON.parse(
  window.sessionStorage.getItem("local_authority") ??
    '{"latitude":51.25,"longitude":-0.24}'
);

export default function getLatLon() {
  return { latitude, longitude };
}
